
import { configureStore } from '@reduxjs/toolkit'
import thunk from 'redux-thunk';

import auth from './auth';
import user from './user';
import unit from './unit';
import subject from './subject';
import meeting from './meeting';
import general from './general';

// Production ortamında Redux DevTools'u tamamen kapatıyoruz.
// Bu değişiklik uygulamanın çalışma mantığını etkilemez; sadece debug görünümünü etkiler.
const isDevelopment = process.env.NODE_ENV === 'development';

// DevTools'ta hassas alanları maskelemek için yardımcılar
const REDACTED = '[GIZLENDI]';
const SENSITIVE_KEYS = new Set([
    'token',
    'accessToken',
    'refreshToken',
    'password',
    'secret',
    'apiKey',
    'authorization',
]);

function deepRedact(value, seen = new WeakSet()) {
    if (value === null || value === undefined) return value;
    if (typeof value !== 'object') return value;
    if (seen.has(value)) return value;
    seen.add(value);

    if (Array.isArray(value)) {
        return value.map((v) => deepRedact(v, seen));
    }

    const out = {};
    for (const [k, v] of Object.entries(value)) {
        if (SENSITIVE_KEYS.has(k)) {
            out[k] = REDACTED;
        } else {
            out[k] = deepRedact(v, seen);
        }
    }
    return out;
}

function sanitizeActionForDevTools(action) {
    if (!action || typeof action !== 'object') return action;

    // Tüm action payload'larını DevTools'ta gizle (uygulama çalışmasını etkilemez)
    // Sadece action type'ı görünür, payload içeriği gizlenir
    const sanitized = { ...action };

    // Payload'ı gizle
    if (sanitized.payload !== undefined) {
        if (Array.isArray(sanitized.payload)) {
            sanitized.payload = `[${sanitized.payload.length} kayıt gizlendi]`;
        } else if (typeof sanitized.payload === 'object' && sanitized.payload !== null) {
            sanitized.payload = '[Payload gizlendi]';
        } else {
            sanitized.payload = '[Gizlendi]';
        }
    }

    // Meta içindeki hassas alanları da temizle
    if (sanitized.meta && typeof sanitized.meta === 'object') {
        sanitized.meta = deepRedact(sanitized.meta);
    }

    return sanitized;
}

function sanitizeStateForDevTools(state) {
    if (!state || typeof state !== 'object') return state;

    // Token artık Redux state'inde yok (sadece localStorage'da), 
    // bu yüzden state sanitizer'a gerek yok
    // İleride başka hassas veriler için kullanılabilir
    return state;
}

const store = configureStore({
    reducer: {
        auth,
        user,
        unit,
        subject,
        meeting,
        general,

    },
    middleware: [thunk],

    devTools: isDevelopment
        ? {
            actionSanitizer: sanitizeActionForDevTools,
            stateSanitizer: sanitizeStateForDevTools,
        }
        : false
})

export default store;